import {
  Content,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
} from './Content';
import { ContentNavigation, ContentSection } from './ContentNavigation';
import { Header } from './Header';
import { Root } from './Root';
import { Title } from './Title';
import {
  FiltersProvider,
  FiltersProviderWithLabels,
  ResourceGuard,
  Wrapper,
} from './Wrapper';

export const Page = {
  Root,
  Title,
  Header,
  ResourceGuard,
  Content,
  ContentNavigation,
  ContentSection,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
  Wrapper,
  FiltersProvider,
  FiltersProviderWithLabels,
};
